import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_query_table = _resolveComponent("query-table")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPreviewClick && _ctx.onPreviewClick(...args))),
      class: _normalizeClass(`container${_ctx.theModel.elementItem.ElementScale === 2 ? '4' :
    (_ctx.theModel.elementItem.ElementScale === 1 ? '2' : '1')}table`)
    }, [
      _createVNode(_component_query_table, {
        class: _normalizeClass(`preview${_ctx.theModel.elementItem.ElementScale === 2 ? '4' :
      (_ctx.theModel.elementItem.ElementScale === 1 ? '2' : '1')}table q-mt-md`),
        modelValue: _ctx.theModel.Element,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel.Element) = $event)),
        "hide-panel": true,
        "src-element": _ctx.theModel.elementItem,
        paginationModel: _ctx.paginationModel
      }, null, 8, ["class", "modelValue", "src-element", "paginationModel"])
    ], 2),
    _createVNode(_component_q_dialog, {
      maximized: "",
      modelValue: _ctx.showFull,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showFull) = $event)),
      persistent: "",
      fit: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.theModel.elementItem.Name), 1),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, {
              style: {"max-height":"90vh","display":"flex"},
              class: "scroll"
            }, {
              default: _withCtx(() => [
                (!_ctx.querystore.isLoading)
                  ? (_openBlock(), _createBlock(_component_query_table, {
                      key: 0,
                      class: "full-width",
                      "is-in-dialog": true,
                      modelValue: _ctx.theModel.Element,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.theModel.Element) = $event)),
                      "src-element": _ctx.theModel.elementItem,
                      "onUpdate:paginationModel": _ctx.onUpdatePagination,
                      paginationModel: _ctx.paginationModel,
                      selectedEverything: _ctx.theModel.selectedAll,
                      "onUpdate:selectedEverything": _ctx.onSelectedAllUpdate,
                      selectedEntities: _ctx.theModel.selectedEntities,
                      "onUpdate:selectedEntities": _ctx.onSelectionUpdate,
                      unselectedEntities: _ctx.theModel.unselectedEntities,
                      "onUpdate:unselectedEntities": _ctx.onUnSelectionUpdate
                    }, null, 8, ["modelValue", "src-element", "onUpdate:paginationModel", "paginationModel", "selectedEverything", "onUpdate:selectedEverything", "selectedEntities", "onUpdate:selectedEntities", "unselectedEntities", "onUpdate:unselectedEntities"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}